import React from 'react';
export function ProofSection() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#FAFAF8'
  }} data-id="element-195">
      <div className="max-w-3xl mx-auto text-center" data-id="element-196">
        {/* Stars */}
        <div className="flex justify-center gap-1 mb-6" aria-label="5 estrellas" data-id="element-197">
          <span className="text-3xl" style={{
          color: '#F59E0B'
        }} data-id="element-198">
            ★
          </span>
          <span className="text-3xl" style={{
          color: '#F59E0B'
        }} data-id="element-199">
            ★
          </span>
          <span className="text-3xl" style={{
          color: '#F59E0B'
        }} data-id="element-200">
            ★
          </span>
          <span className="text-3xl" style={{
          color: '#F59E0B'
        }} data-id="element-201">
            ★
          </span>
          <span className="text-3xl" style={{
          color: '#F59E0B'
        }} data-id="element-202">
            ★
          </span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 leading-tight" style={{
        color: '#1A1A1A',
        fontFamily: 'Plus Jakarta Sans, sans-serif'
      }} data-id="element-203">
          Un sistema probado que funciona desde la primera semana
        </h2>

        {/* Stat callout */}
        <div className="rounded-2xl p-8 mb-10 border border-[#E8E0D8]" style={{
        backgroundColor: '#F5F0EB'
      }} data-id="element-204">
          <p className="text-5xl sm:text-6xl font-extrabold mb-2" style={{
          color: '#FF5A5F',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-205">
            80%
          </p>
          <p className="text-xl font-bold mb-2" style={{
          color: '#1A1A1A',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }} data-id="element-206">
            Reducción en notificaciones entrantes
          </p>
          <p style={{
          color: '#6B7280',
          fontFamily: 'Inter, sans-serif'
        }} className="text-base" data-id="element-207">
            Anfitriones que implementaron el sistema reportan una reducción del
            80% en mensajes de huéspedes desde la primera semana, manteniendo un
            estatus de Superhost consistente.
          </p>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left" data-id="element-208">
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-209">
            <div className="flex gap-0.5 mb-3" aria-label="5 estrellas" data-id="element-210">
              <span style={{
              color: '#F59E0B'
            }} data-id="element-211">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-212">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-213">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-214">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-215">
                ★
              </span>
            </div>
            <p className="text-base leading-relaxed mb-4 italic" style={{
            color: '#1A1A1A',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-216">
              "Antes recibía 10-15 mensajes por estadía. Ahora recibo 1 o 2, y
              casi siempre son para decirme que todo está perfecto."
            </p>
            <p className="text-sm font-semibold" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-217">
              — Carlos M., anfitrión en Miami · 3 propiedades
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-[#E8E0D8]" data-id="element-218">
            <div className="flex gap-0.5 mb-3" aria-label="5 estrellas" data-id="element-219">
              <span style={{
              color: '#F59E0B'
            }} data-id="element-220">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-221">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-222">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-223">
                ★
              </span>
              <span style={{
              color: '#F59E0B'
            }} data-id="element-224">
                ★
              </span>
            </div>
            <p className="text-base leading-relaxed mb-4 italic" style={{
            color: '#1A1A1A',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-225">
              "Tengo trabajo de tiempo completo. Este sistema me permitió
              mantener mi Superhost sin revisar el teléfono cada hora."
            </p>
            <p className="text-sm font-semibold" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-226">
              — Ana L., co-host en Houston · 5 unidades
            </p>
          </div>
        </div>

        {/* Superhost badge */}
        <div className="mt-10 flex justify-center" data-id="element-227">
          <div className="inline-flex items-center gap-3 rounded-full px-6 py-3 border border-[#E8E0D8] shadow-sm" style={{
          backgroundColor: '#F5F0EB'
        }} data-id="element-228">
            <span className="text-2xl" role="img" aria-label="Superhost" data-id="element-229">
              🏆
            </span>
            <span className="font-bold text-base" style={{
            color: '#1A1A1A',
            fontFamily: 'Plus Jakarta Sans, sans-serif'
          }} data-id="element-230">
              Compatible con el programa Superhost de Airbnb
            </span>
          </div>
        </div>
      </div>
    </section>;
}